import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { Box, Paper } from "@mui/material";
import { useQuickStart } from "@/pages/organizations/detail/quick-start";
import GuideStepper from "@/features/guides/components/quick-start/GuideStepper";
import StepTwo from "@/features/guides/components/quick-start/Step2";

export const Route = createFileRoute("/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/guide")({
  component: RouteComponent,
});

const steps = ["Select Topic", "Answer Questions", "Get Your Guide"];

function RouteComponent() {
  const { subtopicId: urlSubtopicId } = Route.useParams();

  const {
    subtopicId,
    setSubtopicId,
    guides,
    setSelectedTopicId,
    setCurrentGuideId,
    refreshLinkedCriteria,
    navigateToStepOne,
  } = useQuickStart();

  const activeStep = 2;
  const isStepSkipped = () => false;

  // Sync subtopicId from URL
  useEffect(() => {
    const numericSubtopicId = Number(urlSubtopicId);
    if (numericSubtopicId && numericSubtopicId !== subtopicId) {
      setSubtopicId(numericSubtopicId);
    }
  }, [urlSubtopicId, subtopicId, setSubtopicId]);

  // Set topic/guide info once we have subtopicId and guides loaded
  useEffect(() => {
    if (!subtopicId || guides.length === 0) return;

    const guide = guides.find((g) => g.criterion_subtopic_id === subtopicId);
    if (guide) {
      setSelectedTopicId(guide.criterion_topic.id);
      setCurrentGuideId(guide.id ?? undefined);
    }
  }, [subtopicId, guides, setSelectedTopicId, setCurrentGuideId]);

  // Load linked criteria when entering step 2
  useEffect(() => {
    if (subtopicId) {
      refreshLinkedCriteria();
    }
  }, [subtopicId, refreshLinkedCriteria]);

  if (!subtopicId) {
    return null; // Wait for subtopicId to be set from URL
  }

  return (
    <Box>
      <Box component="h2">Your Guide</Box>
      <Paper variant="elevation" elevation={5}>
        <GuideStepper
          activeStep={activeStep}
          handleBack={navigateToStepOne}
          steps={steps}
          isStepSkipped={isStepSkipped}
        />
        <StepTwo onGoToQuestion={navigateToStepOne} />
      </Paper>
    </Box>
  );
}
